var _path, _path2, _circle;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInstagram = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.013,
    height: 20.013,
    viewBox: "0 0 20.013 20.013",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "grey-mode",
    d: "M14.051,0H5.962A5.969,5.969,0,0,0,0,5.962v8.089a5.969,5.969,0,0,0,5.962,5.962h8.089a5.969,5.969,0,0,0,5.962-5.962V5.962A5.969,5.969,0,0,0,14.051,0ZM18,14.051A3.949,3.949,0,0,1,14.051,18H5.962a3.949,3.949,0,0,1-3.949-3.949V5.962A3.949,3.949,0,0,1,5.962,2.013h8.089A3.949,3.949,0,0,1,18,5.962v8.089Z",
    fill: "#e4405f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "grey-mode",
    d: "M138.176,133a5.176,5.176,0,1,0,5.176,5.176A5.182,5.182,0,0,0,138.176,133Zm0,8.339a3.163,3.163,0,1,1,3.163-3.163A3.163,3.163,0,0,1,138.176,141.339Z",
    transform: "translate(-128.17 -128.17)",
    fill: "#e4405f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "grey-mode",
    cx: 1.24,
    cy: 1.24,
    r: 1.24,
    transform: "translate(13.952 3.629)",
    fill: "#e4405f"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.3fade742.svg";
export { ForwardRef as ReactComponent };